import { types, flow, getRoot, getSnapshot } from 'mobx-state-tree'
import { Jurisdiction } from 'store/models/other/jurisdiction'

export const Team = types
  .model('TeamModel', {
    id: types.identifierNumber,
    teamName: types.string,
    jurisdiction: types.maybeNull(Jurisdiction),
    league: types.maybeNull(types.string),
    logo: types.maybeNull(types.string),
    sport: types.maybeNull(types.string),
    teamWebsite: types.maybeNull(types.string),
    athletes: types.optional(types.array(types.number), []),
  })
  .preProcessSnapshot((snapshot) => {
    if (!snapshot) return { id: 0, teamName: '' };

    return {
      ...snapshot,
      athletes: snapshot.athletesIds || [],
    };
  })
  .actions((self) => {
    const { athletes: athletesStore } = getRoot(self)

    return {
      loadAthletes: flow(function* () {
        if (!self.athletes) return [];

        const athleteIds = getSnapshot(self.athletes) || [];
        if (!athleteIds.length) return [];

        try {
          const loadedAthletes = yield Promise.all(
            athleteIds.map((id) => athletesStore.loadOne(id))
          );
          return loadedAthletes;
        } catch (error) {
          return [];
        }
      }),
    }
  })
